import request from "../../request.js";
import request2 from "../../request2.js"
import qs from "qs";

// 上次文件
export function uploadFileToYdy(data) {
  return request({
    url: "/ydy-file/uploadFileToYdy",
    method: "POST",
    data,
  });
}
// 上传文件到腾讯云-后端
export function uploadFileToTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/uploadFileToTxCloudEquityFee",
    method: "POST",
    data,
  });
}
// 新增用户
export function addAjefUser(data) {
  return request({
    url: "/ajef-user/addAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取腾讯云秘钥
export function getPolicyTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/getPolicyTxCloudEquityFee",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取用户列表
export function getAjefUserList(data) {
  return request({
    url: "/ajef-user/getAjefUserList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑用户
export function updateAjefUser(data) {
  return request({
    url: "/ajef-user/updateAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 登录
export function doLogin(data) {
  return request({
    url: "/ajef-user/doLogin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除用户
export function deleteAjefUser(data) {
  return request({
    url: "/ajef-user/deleteAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户
export function addAjefShop(data) {
  return request({
    url: "/ajef-shop/addAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除商户
export function deleteAjefShop(data) {
  return request({
    url: "/ajef-shop/deleteAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户
export function getAjefShopList(data) {
  return request({
    url: "/ajef-shop/getAjefShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户
export function getAjefShopListQuick(data) {
  return request({
    url: "/ajef-shop/getAjefShopListQuick",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户-详情
export function getAjefShopDetails(data) {
  return request({
    url: "/ajef-shop/getAjefShopDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户-编辑
export function updateAjefShop(data) {
  return request({
    url: "/ajef-shop/updateAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑商户排序
export function updateAjefShopOrder(data) {
  return request({
    url: "/ajef-shop/updateAjefShopOrder",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户账单
export function getAjefShopBillList(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量生成卷
export function addAjefCertificateRecordMulti(data) {
  return request({
    url: "/ajef-certificate-record/addAjefCertificateRecordMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量撤销卷
export function cancelAjefCertificateRecordMulti(data) {
  return request({
    url: "/ajef-certificate-record/cancelAjefCertificateRecordMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-处理失败的进行处理（更新核查状态与描述）
export function updateAjefCertificateRecordCopyCheckDes(data) {
  return request({
    url: "/ajef-certificate-statistics-check/updateAjefCertificateRecordCopyCheckDes",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-查询关联的订单和账单（返回列表）
export function getAjefCertificateRecordCopyCheckOrderBill(data) {
  return request({
    url: "/ajef-certificate-statistics-check/getAjefCertificateRecordCopyCheckOrderBill",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-添加账单
export function addAjefCertificateRecordCopyCheckBill(data) {
  return request({
    url: "/ajef-certificate-statistics-check/addAjefCertificateRecordCopyCheckBill",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-扣减权益金
export function addAjefCertificateRecordCopyCheckOrder(data) {
  return request({
    url: "/ajef-certificate-statistics-check/addAjefCertificateRecordCopyCheckOrder",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码对账核查-添加订单记录
export function addAjefCertificateRecordCopyCheckOrderRecord(data) {
  return request({
    url: "/ajef-certificate-statistics-check/addAjefCertificateRecordCopyCheckOrderRecord",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询卷记录
export function getAjefCertificateRecordList(data) {
  return request({
    url: "/ajef-certificate-record/getAjefCertificateRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-查询列表
export function getAjefCertificateRecordSpecsList(data) {
  return request({
    url: "/ajef-certificate-record-specs/getAjefCertificateRecordSpecsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-新增
export function addAjefCertificateRecordSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs/addAjefCertificateRecordSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-编辑
export function updateAjefCertificateRecordSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs/updateAjefCertificateRecordSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码规格-删除
export function deleteAjefCertificateRecordSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs/deleteAjefCertificateRecordSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券码查看记录-查询列表
export function getAjefCertificateRecordLookList(data) {
  return request({
    url: "/ajef-certificate-record-look/getAjefCertificateRecordLookList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券记录未领取-查询列表
export function getAjefCertificateRecordSubList(data) {
  return request({
    url: "/ajef-certificate-record-sub/getAjefCertificateRecordSubList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 券记录未领取-退款
export function updateAjefCertificateRecordSubRefund(data) {
  return request({
    url: "/ajef-certificate-record-sub/updateAjefCertificateRecordSubRefund",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户管理员
export function addAjefUserShopAdmin(data) {
  return request({
    url: "/ajef-user-shop/addAjefUserShopAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户核销员
export function addAjefUserShopUser(data) {
  return request({
    url: "/ajef-user-shop/addAjefUserShopUser",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 删除商户用户
export function deleteAjefUserShop(data) {
  return request({
    url: "/ajef-user-shop/deleteAjefUserShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户用户
export function getAjefUserShopList(data) {
  return request({
    url: "/ajef-user-shop/getAjefUserShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑商户用户
export function updateAjefUserShop(data) {
  return request({
    url: "/ajef-user-shop/updateAjefUserShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户账单新
export function getAjefShopBillListp(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillListp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现申请
export function getAjefApplyWithdrawList(data) {
  return request({
    url: "/ajef-apply-withdraw/getAjefApplyWithdrawList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//微信账单回调
export function getWxPayNotifyList(data) {
  return request({
    url: "/wx-pay-notify/getWxPayNotifyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-新增发票通知
export function addAjefShopReceipt(data) {
  return request({
    url: "/ajef-shop-receipt/addAjefShopReceipt",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票通知
export function getAjefShopReceiptList(data) {
  return request({
    url: "/ajef-shop-receipt/getAjefShopReceiptList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票审核
export function updateAjefShopReceiptStatusCheck(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-驳回
export function updateAjefShopReceiptStatusCheckRevoke(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusCheckRevoke",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票通知
export function updateAjefShopReceiptStatusSend(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//对公打款编辑账单信息
export function updateAjefApplyWithdrawPayment(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPayment",
    method: "POST",
    data: qs.stringify(data),
  });
}
//用户修改密码
export function updateAjefUserPw(data) {
  return request({
    url: "/ajef-user/updateAjefUserPw",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核-通过
export function updateAjefShopCheckPass(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核-不通过
export function updateAjefShopCheckNotPass(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户账单-详情
export function getAjefShopBillDetails(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户开票结算类型
export function getAjefShopReceiptTypeList(data) {
  return request({
    url: "/ajef-shop-receipt-type/getAjefShopReceiptTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统日志
export function getSysLogList(data) {
  return request({
    url: "/sys-log/getSysLogList",
    method: "POST",
    data,
  });
}
//新增银行卡可选范围
export function addAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/addAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑银行可选范围
export function updateAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/updateAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除银行可选范围
export function deleteAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/deleteAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取银行可选范围
export function getAjefShopBankOptinonsList(data) {
  return request({
    url: "/ajef-shop-bank-optinons/getAjefShopBankOptinonsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户用户列表
export function getAjefUserShopBindList(data) {
  return request({
    url: "/ajef-user-shop-bind/getAjefUserShopBindList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询地区
export function getSysRegionList(data) {
  return request({
    url: "/sys-region/getSysRegionList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户充值奖励请
export function updateAjefShopCheckPassGift(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckPassGift",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增地区信息
export function addSysRegion(data) {
  return request({
    url: "/sys-region/addSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑地区信息
export function updateSysRegion(data) {
  return request({
    url: "/sys-region/updateSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除地区信息
export function deleteSysRegion(data) {
  return request({
    url: "/sys-region/deleteSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取权限列表
export function getAjefAuthList(data) {
  return request({
    url: "/ajef-auth/getAjefAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增权限列表
export function addAjefAuth(data) {
  return request({
    url: "/ajef-auth/addAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除权限列表
export function deleteAjefAuth(data) {
  return request({
    url: "/ajef-auth/deleteAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑权限列表
export function updateAjefAuth(data) {
  return request({
    url: "/ajef-auth/updateAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取树权限列表
export function getAjefAuthTree(data) {
  return request({
    url: "/ajef-auth/getAjefAuthTree",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新建角色
export function addAjefRole(data) {
  return request({
    url: "/ajef-role/addAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除角色
export function deleteAjefRole(data) {
  return request({
    url: "/ajef-role/deleteAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色权限
export function getAjefRoleAuthList(data) {
  return request({
    url: "/ajef-role/getAjefRoleAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色列表
export function getAjefRoleList(data) {
  return request({
    url: "/ajef-role/getAjefRoleList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色列表
export function updateAjefRole(data) {
  return request({
    url: "/ajef-role/updateAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色权限
export function updateAjefRoleAuth(data) {
  return request({
    url: "/ajef-role/updateAjefRoleAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核列表
export function getAjefShopReceiptTypeChangeApplyList(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/getAjefShopReceiptTypeChangeApplyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核-不通过
export function updateAjefShopReceiptTypeCheckNotPass(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/updateAjefShopReceiptTypeCheckNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核-通过
export function updateAjefShopReceiptTypeCheckPass(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/updateAjefShopReceiptTypeCheckPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-新增
export function addAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/addAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-编辑
export function updateAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/updateAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-编辑
export function getAjefCertificateRecordRelationXiaoxiangList(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/getAjefCertificateRecordRelationXiaoxiangList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-删除
export function deleteAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/deleteAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增移动公司存量客户
export function addAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/addAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑移动公司存量客户
export function updateAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/updateAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除移动公司存量客户
export function deleteAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/deleteAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取移动公司存量客户
export function getAjefShopStockYidongList(data) {
  return request({
    url: "/ajef-shop-stock-yidong/getAjefShopStockYidongList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//批量导入移动公司存量客户
export function uploadAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/uploadAjefShopStockYidong",
    method: "POST",
    data,
  });
}
//主页获取用户权限
export function getAjefUserDetailsRefresh(data) {
  return request({
    url: "/ajef-user/getAjefUserDetailsRefresh",
    method: "POST",
    data: qs.stringify(data),
  });
}
//主页获取用户所有通知
export function getAjefUserNoticeTotal(data) {
  return request({
    url: "/ajef-user/getAjefUserNoticeTotal",
    method: "POST",
    data: qs.stringify(data),
  });
}
//主页获取用户所有通知数量
export function getAjefUserNoticeTotalNum(data) {
  return request({
    url: "/ajef-user/getAjefUserNoticeTotalNum",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核查询
export function updateAjefShopCheckBefore(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckBefore",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增商品兑换收集
export function addAjefShopCollectionGoods(data) {
  return request({
    url: "/ajef-shop-collection-goods/addAjefShopCollectionGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商品兑换收集
export function getAjefShopCollectionGoodsList(data) {
  return request({
    url: "/ajef-shop-collection-goods/getAjefShopCollectionGoodsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑商品兑换收集
export function updateAjefShopCollectionGoods(data) {
  return request({
    url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoods",
    method: "POST",
    data: qs.stringify(data),
  });
}
//暂停商品兑换收集
export function updateAjefShopCollectionGoodsDown(data) {
  return request({
    url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoodsDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发布商品兑换收集
export function updateAjefShopCollectionGoodsUp(data) {
  return request({
    url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoodsUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商户上传商品兑换收集
export function getAjefShopCollectionGoodsRecordList(data) {
  return request({
    url: "/ajef-shop-collection-goods-record/getAjefShopCollectionGoodsRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除商户上传商品兑换收集
export function deleteAjefShopCollectionGoodsRecord(data) {
  return request({
    url: "/ajef-shop-collection-goods-record/deleteAjefShopCollectionGoodsRecord",
    method: "POST",
    data: qs.stringify(data),
  });
}
//地市权限查询核销账单
export function getAjefShopBillListCustomer(data) {
  return request({
    url: "/certificate_record-customer/getAjefShopBillListCustomer",
    method: "POST",
    data: qs.stringify(data),
  });
}
//地市权限查询商户
export function getAjefShopListCustomer(data) {
  return request({
    url: "/certificate_record-customer/getAjefShopListCustomer",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商户地市
export function getAjefShopCityList(data) {
  return request({
    url: "/ajef-shop-city/getAjefShopCityList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询商户区县
export function getAjefShopCityDistrictList(data) {
  return request({
    url: "/ajef-shop-city-district/getAjefShopCityDistrictList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑商户区县
export function updateAjefShopCityDistrict(data) {
  return request({
    url: "/ajef-shop-city-district/updateAjefShopCityDistrict",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑商户地市
export function updateAjefShopCity(data) {
  return request({
    url: "/ajef-shop-city/updateAjefShopCity",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款申请
export function getAjefShopBillRevokeList(data) {
  return request({
    url: "/ajef-shop-bill-revoke/getAjefShopBillRevokeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款申请-处理
export function updateAjefShopBillRevokeHandler(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillRevokeHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款申请-处理退款-同步退权益金
export function updateAjefShopBillRevokeHandlerYd(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillRevokeHandlerYd",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑关键值
export function updateSysOurageKey(data) {
  return request({
    url: "/sys-ourage-key/updateSysOurageKey",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑关键值
export function getSysOurageKeyList(data) {
  return request({
    url: "/sys-ourage-key/getSysOurageKeyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//批量导入已入账发票信息
export function uploadAjefShopReceiptInBill(data) {
  return request({
    url: "/ajef-shop-receipt/uploadAjefShopReceiptInBill",
    method: "POST",
    data,
  });
}
//财务统计 -总的
export function getAjefCertificateRecordStatisticsYear(data) {
  return request({
    url: "/ajef-certificate-record-statistics/getAjefCertificateRecordStatisticsYear",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计 -商户总的
export function getAjefCertificateRecordStatisticsYearShop(data) {
  return request({
    url: "/ajef-certificate-record-statistics/getAjefCertificateRecordStatisticsYearShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-查询
export function getSysNoticeList(data) {
  return request({
    url: "/sys-notice/getSysNoticeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-删除
export function deleteSysNoticeRead(data) {
  return request({
    url: "/sys-notice/deleteSysNoticeRead",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-分类标题
export function getSysNoticeListTitle(data) {
  return request({
    url: "/sys-notice/getSysNoticeListTitle",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-已读
export function updateSysNoticeRead(data) {
  return request({
    url: "/sys-notice/updateSysNoticeRead",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-未通知数量
export function getSysNoticeUnReadNum(data) {
  return request({
    url: "/sys-notice/getSysNoticeUnReadNum",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通知-一键已读
export function updateSysNoticeReadAll(data) {
  return request({
    url: "/sys-notice/updateSysNoticeReadAll",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-新增
export function addSysBulletin(data) {
  return request({
    url: "/sys-bulletin/addSysBulletin",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-查询
export function getSysBulletinList(data) {
  return request({
    url: "/sys-bulletin/getSysBulletinList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-编辑
export function updateSysBulletin(data) {
  return request({
    url: "/sys-bulletin/updateSysBulletin",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-下架
export function updateSysBulletinDown(data) {
  return request({
    url: "/sys-bulletin/updateSysBulletinDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-上架
export function updateSysBulletinUp(data) {
  return request({
    url: "/sys-bulletin/updateSysBulletinUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//通告-查询阅读记录
export function getSysBulletinReadList(data) {
  return request({
    url: "/sys-bulletin-read/getSysBulletinReadList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//核销明细-查询列表
export function getAjefCertificateStatisticsCheckList(data) {
  return request({
    url: "/ajef-certificate-statistics-check/getAjefCertificateStatisticsCheckList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//核销明细-查询列表
export function getAjefCertificateStatisticsCheckListCustomer(data) {
  return request({
    url: "/certificate_record-customer/getAjefCertificateStatisticsCheckListCustomer",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录新增
export function addAjefApplyRecharge(data) {
  return request({
    url: "/ajef-apply-recharge/addAjefApplyRecharge",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录编辑
export function updateAjefApplyRecharge(data) {
  return request({
    url: "/ajef-apply-recharge/updateAjefApplyRecharge",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录查询
export function getAjefApplyRechargeList(data) {
  return request({
    url: "/ajef-apply-recharge/getAjefApplyRechargeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//财务统计-充值记录查询
export function getAjefApplyRechargeRemaining(data) {
  return request({
    url: "/ajef-apply-recharge/getAjefApplyRechargeRemaining",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-新增
export function addAjefShopAgain(data) {
  return request({
    url: "/ajef-shop-again/addAjefShopAgain",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-审核不通过
export function updateAjefShopAgainNotPass(data) {
  return request({
    url: "/ajef-shop-again/updateAjefShopAgainNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-审核通过
export function updateAjefShopAgainPass(data) {
  return request({
    url: "/ajef-shop-again/updateAjefShopAgainPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-商户复核-列表
export function getAjefShopAgainList(data) {
  return request({
    url: "/ajef-shop-again/getAjefShopAgainList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-里程碑
export function getAjefShopMilestoneList(data) {
  return request({
    url: "/ajef-shop-milestone/getAjefShopMilestoneList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-修改商户类型
export function updateAjefShopTypeShop(data) {
  return request({
    url: "/ajef-shop/updateAjefShopTypeShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户管理-修改分账类型
export function updateAjefShopBillShareTypeShop(data) {
  return request({
    url: "/ajef-shop/updateAjefShopBillShareTypeShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录列表
export function getAjefShopBillDifferenceReceiptList(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/getAjefShopBillDifferenceReceiptList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录新增
export function addAjefShopBillDifferenceReceipt(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/addAjefShopBillDifferenceReceipt",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录取消
export function updateAjefShopBillDifferenceReceiptCancel(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/updateAjefShopBillDifferenceReceiptCancel",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票 - 发票补差价记录处理
export function updateAjefShopBillDifferenceReceiptHandler(data) {
  return request({
    url: "/ajef-shop-bill-difference-receipt/updateAjefShopBillDifferenceReceiptHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}
//日志-活跃统计
export function getSysLogStatisticsList(data) {
  return request({
    url: "/sys-log-statistics/getSysLogStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//日志-活跃统计时间段
export function getSysLogStatisticsDetails(data) {
  return request({
    url: "/sys-log-statistics/getSysLogStatisticsDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-退款
export function updateAjefShopBillShopRevokeAdmin(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillShopRevokeAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}
//账单-驳回退款
export function updateAjefShopBillRevokeHandlerReject(data) {
  return request({
    url: "/ajef-shop-bill-revoke/updateAjefShopBillRevokeHandlerReject",
    method: "POST",
    data: qs.stringify(data),
  });
}
//禁用商户
export function updateAjefShopDisable(data) {
  return request({
    url: "/ajef-shop/updateAjefShopDisable",
    method: "POST",
    data: qs.stringify(data),
  });
}
//解禁商户
export function updateAjefShopEnable(data) {
  return request({
    url: "/ajef-shop/updateAjefShopEnable",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-禁用核销
export function updateAjefShopDisableHeXiao(data) {
  return request({
    url: "/ajef-shop/updateAjefShopDisableHeXiao",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-解禁核销
export function updateAjefShopEnableHeXiao(data) {
  return request({
    url: "/ajef-shop/updateAjefShopEnableHeXiao",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-批量禁用核销
export function updateAjefShopDisableHeXiaoMulti(data) {
  return request({
    url: "/ajef-shop/updateAjefShopDisableHeXiaoMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-批量解禁核销
export function updateAjefShopEnableHeXiaoMulti(data) {
  return request({
    url: "/ajef-shop/updateAjefShopEnableHeXiaoMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现记录-编辑对公打款
export function updateAjefApplyWithdrawPaymentDes(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPaymentDes",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现-对公打款-系统管理员
export function addAjefApplyWithdrawPublicSys(data) {
  return request({
    url: "/ajef-apply-withdraw/addAjefApplyWithdrawPublicSys",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户-对公信息校验
export function updateAjefShopBankCheck(data) {
  return request({
    url: "/ajef-shop/updateAjefShopBankCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}
//特殊卡劵-附加信息核销记录
export function getAjefCertificateRecordExpandDetectorList(data) {
  return request({
    url: "/ajef-certificate-record-expand-detector/getAjefCertificateRecordExpandDetectorList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//特殊卡劵-重新同步
export function updateAjefCertificateRecordExpandDetectorUserState(data) {
  return request({
    url: "/ajef-certificate-record-expand-detector/updateAjefCertificateRecordExpandDetectorUserState",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现申请 - 批量处理对公打款
export function updateAjefApplyWithdrawPaymentMulti(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPaymentMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现申请 - 批量编辑对公打款
export function updateAjefApplyWithdrawPaymentDesMulti(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPaymentDesMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 新增记录
export function addAjefApplyWithdrawAdvanceSys(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/addAjefApplyWithdrawAdvanceSys",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 记录
export function getAjefApplyWithdrawAdvanceSysList(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/getAjefApplyWithdrawAdvanceSysList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 取消记录
export function updateAjefApplyWithdrawAdvanceSysCancel(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/updateAjefApplyWithdrawAdvanceSysCancel",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统对公提现申请记录 - 通过发送
export function updateAjefApplyWithdrawAdvanceSysSend(data) {
  return request({
    url: "/ajef-apply-withdraw-advance-sys/updateAjefApplyWithdrawAdvanceSysSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户发票记录-其他信息
export function updateAjefShopReceipt(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceipt",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户发票记录-批量修改处理时间
export function updateAjefShopReceiptStatusCheckMulti(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusCheckMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
//存量日志
export function getSysLogCopyList(data) {
  return request({
    url: "/sys-log-copy/getSysLogCopyList",
    method: "POST",
    data
  });
}
//存量日志-复制日志
export function updateSysLogCopyDo(data) {
  return request({
    url: "/sys-log-copy/updateSysLogCopyDo",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录-导出
export function exportAjefCertificateRecordXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/exportAjefCertificateRecordXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录
export function getAjefCertificateRecordXiaoxiangList(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/getAjefCertificateRecordXiaoxiangList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录-导入小象兑换券记录
export function uploadAjefCertificateRecordXiaoxiangOne(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/uploadAjefCertificateRecordXiaoxiangOne",
    method: "POST",
    data
  });
}
//小象领取记录-导入小象兑换券记录关联劵码
export function uploadAjefCertificateRecordXiaoxiangTwo(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang/uploadAjefCertificateRecordXiaoxiangTwo",
    method: "POST",
    data
  });
}
//小象领取记录-统计
export function getAjefCertificateRecordXiaoxiangStatisticsList(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-statistics/getAjefCertificateRecordXiaoxiangStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//小象领取记录-重新计算
export function getAjefCertificateRecordXiaoxiangStatisticsSumAgain(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-statistics/getAjefCertificateRecordXiaoxiangStatisticsSumAgain",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户通告列表-上传商户获取id
export function uploadShopReturnAsIdsList(data) {
  return request({
    url: "/sys-bulletin/uploadShopReturnAsIdsList",
    method: "POST",
    data,
  });
}
//发票管理-平台上传发票
export function updateAjefShopReceiptFiles(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptFiles",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票明细统计-记录
export function getAjefCertificateRecordXiaoxiangReceiptList(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-receipt/getAjefCertificateRecordXiaoxiangReceiptList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票明细统计-执行
export function updateAjefCertificateRecordXiaoxiangReceiptHandler(data) {
  return request({
    url: "/ajef-certificate-record-xiaoxiang-receipt/updateAjefCertificateRecordXiaoxiangReceiptHandler",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作错误记录
export function getAjefRightsFundErrorList(data) {
  return request2({
    url: "/ajef-rights-fund-error/getAjefRightsFundErrorList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作记录详情
export function getAjefRightsFundBillDetails(data) {
  return request2({
    url: "/ajef-rights-fund-bill/getAjefRightsFundBillDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作记录
export function getAjefRightsFundBillList(data) {
  return request2({
    url: "/ajef-rights-fund-bill/getAjefRightsFundBillList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金回退记录
export function getAjefRightsFundRollbackList(data) {
  return request2({
    url: "/ajef-rights-fund-rollback/getAjefRightsFundRollbackList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金扣减记录
export function getAjefRightsFundDeductList(data) {
  return request2({
    url: "/ajef-rights-fund-deduct/getAjefRightsFundDeductList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金扣减记录-系统操作回退
export function updateAjefRightsFundDeductRollback(data) {
  return request2({
    url: "/ajef-rights-fund-deduct/updateAjefRightsFundDeductRollback",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作日志-Two
export function getSysLogListTwo(data) {
  return request2({
    url: "/sys-log/getSysLogList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金日志活跃统计-Two
export function getSysLogStatisticsListTwo(data) {
  return request2({
    url: "/sys-log-statistics/getSysLogStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金日志活跃统计时间段-Two
export function getSysLogStatisticsDetailsTwo(data) {
  return request2({
    url: "/sys-log-statistics/getSysLogStatisticsDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作日志复制迁移-Two
export function getSysLogCopyListTwo(data) {
  return request2({
    url: "/sys-log-copy/getSysLogCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//权益金操作日志-复制迁移执行-Two
export function updateSysLogCopyDoTwo(data) {
  return request2({
    url: "/sys-log-copy/updateSysLogCopyDo",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 黑名单相关 ====================
// 新建黑名单
export function addSysBlacklist(data) {
  return request({
    url: "/sys-blacklist/addSysBlacklist",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除黑名单
export function deleteSysBlacklist(data) {
  return request({
    url: "/sys-blacklist/deleteSysBlacklist",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询黑名单
export function getSysBlacklistList(data) {
  return request({
    url: "/sys-blacklist/getSysBlacklistList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询黑名单手机号集合
export function getSysBlacklistListQuick(data) {
  return request({
    url: "/sys-blacklist/getSysBlacklistListQuick",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑黑名单
export function updateSysBlacklist(data) {
  return request({
    url: "/sys-blacklist/updateSysBlacklist",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 北国超市订单记录 ====================
// 北国超市订单记录
export function getAjefBillBeiguoList(data) {
  return request({
    url: "/ajef-bill-beiguo/getAjefBillBeiguoList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 北国超市订单-退款
export function updateAjefBillBeiguoRefund(data) {
  return request({
    url: "/ajef-bill-beiguo/updateAjefBillBeiguoRefund",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 北国超市订单-状态核查
export function getAjefBillBeiguoOneCheck(data) {
  return request({
    url: "/ajef-bill-beiguo/getAjefBillBeiguoOneCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 北国券码规格 ====================
// 北国券码规格列表
export function getAjefCertificateRecordSpecsBeiguoList(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/getAjefCertificateRecordSpecsBeiguoList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增北国券码规格
export function addAjefCertificateRecordSpecsBeiguo(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/addAjefCertificateRecordSpecsBeiguo",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑北国券码规格
export function updateAjefCertificateRecordSpecsBeiguo(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/updateAjefCertificateRecordSpecsBeiguo",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除北国券码规格
export function deleteAjefCertificateRecordSpecsBeiguo(data) {
  return request({
    url: "/ajef-certificate-record-specs-beiguo/deleteAjefCertificateRecordSpecsBeiguo",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 商户规格关联 ====================
// 商户规格关联
export function addOrUpdateAjefCertificateRecordSpecsRelationShop(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/addOrUpdateAjefCertificateRecordSpecsRelationShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询商户商品规格详情
export function getAjefShopDetailsGoodsSpecs(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/getAjefShopDetailsGoodsSpecs",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-上架
export function updateAjefCertificateRecordSpecsRelationShopUp(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/updateAjefCertificateRecordSpecsRelationShopUp",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-下架
export function updateAjefCertificateRecordSpecsRelationShopDown(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/updateAjefCertificateRecordSpecsRelationShopDown",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-审核
export function updateAjefCertificateRecordSpecsRelationShopCheck(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/updateAjefCertificateRecordSpecsRelationShopCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-列表查询
export function getAjefCertificateRecordSpecsRelationShopList(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/getAjefCertificateRecordSpecsRelationShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户规格关联-导出excel
export function exportAjefCertificateRecordSpecsRelationShop(data) {
  return request({
    url: "/ajef-certificate-record-specs-relation-shop/exportAjefCertificateRecordSpecsRelationShop",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 北国券码使用通知 ====================
// 北国券码使用通知
export function getBillBeiguoNotifyList(data) {
  return request({
    url: "/billBeiguoNotify/getBillBeiguoNotifyList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 商户类型 ====================
// 商户类型-列表查询
export function getAjefShopTypeList(data) {
  return request({
    url: "/ajef-shop-type/getAjefShopTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户类型-编辑
export function updateAjefShopType(data) {
  return request({
    url: "/ajef-shop-type/updateAjefShopType",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 分账类型-获取列表
export function getAjefShopBillShareTypeList(data) {
  return request({
    url: "/ajef-shop/getAjefShopBillShareTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 编辑商户地市和名称
export function updateAjefShopCityAndName(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCityAndName",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 权益金余额查询 ====================
// 权益金余额查询-查询余额
export function getYdApiBalanceData(data) {
  return request2({
    url: "/ydApi/getYdApiBalanceData",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 权益金余额查询-查询流水记录
export function getYdApiBalanceRecordList(data) {
  return request2({
    url: "/ydApi/getYdApiBalanceRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 全量商品(报备移动商品记录) ====================
// 全量商品-列表查询
export function getAjefGoodsYdList(data) {
  return request({
    url: "/ajef-goods-yd/getAjefGoodsYdList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 全量商品-新增
export function addAjefGoodsYd(data) {
  return request({
    url: "/ajef-goods-yd/addAjefGoodsYd",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 全量商品-编辑
export function updateAjefGoodsYd(data) {
  return request({
    url: "/ajef-goods-yd/updateAjefGoodsYd",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 全量商品-删除
export function deleteAjefGoodsYd(data) {
  return request({
    url: "/ajef-goods-yd/deleteAjefGoodsYd",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 短信注册记录 ====================
// 短信注册记录-列表查询
export function getSysRegisterCodeList(data) {
  return request({
    url: "/sys-register-code/getSysRegisterCodeList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 全量扣减记录(订单记录) ====================
// 权益金扣减记录(订单记录)-列表查询
export function getAjefRightsFundDeductCopyList(data) {
  return request({
    url: "/ajef-rights-fund-deduct-copy/getAjefRightsFundDeductCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 权益金扣减记录-运营描述
export function updateAjefRightsFundDeductCopyHandlerOperation(data) {
  return request({
    url: "/ajef-rights-fund-deduct-copy/updateAjefRightsFundDeductCopyHandlerOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 全量回退记录(退款记录) ====================
// 权益金回退记录(退款记录)-列表查询
export function getAjefRightsFundRollbackCopyList(data) {
  return request({
    url: "/ajef-rights-fund-rollback-copy/getAjefRightsFundRollbackCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 易宝通订单相关 ====================
// 易宝通订单-列表查询
export function getYbtPayOrderList(data) {
  return request2({
    url: "/ybt-pay-order/getYbtPayOrderList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单-详情查询
export function getYbtPayOrderDetails(data) {
  return request2({
    url: "/ybt-pay-order/getYbtPayOrderDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通异步通知记录-列表查询
export function getYbtPayOrderNotifyList(data) {
  return request2({
    url: "/ybt-pay-order-notify/getYbtPayOrderNotifyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 支付接口响应结果-列表查询
export function getYbtPayOrderResponseList(data) {
  return request2({
    url: "/ybt-pay-order-response/getYbtPayOrderResponseList",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 易宝通订单Copy相关 ====================
// 易宝通订单Copy-列表查询
export function getYbtPayOrderCopyList(data) {
  return request({
    url: "/ybt-pay-order-copy/getYbtPayOrderCopyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单Copy-详情查询
export function getYbtPayOrderCopyDetails(data) {
  return request({
    url: "/ybt-pay-order-copy/getYbtPayOrderCopyDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单Copy-运营描述
export function updatYbtPayOrderCopyHandlerOperation(data) {
  return request({
    url: "/ybt-pay-order-copy/updatYbtPayOrderCopyHandlerOperation",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 易宝通订单Copy-导出excel
export function exportYbtPayOrderCopy(data) {
  return request({
    url: "/ybt-pay-order-copy/exportYbtPayOrderCopy",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 商户其他信息（商户介绍） ====================
// 商户其他信息-获取详情
export function getAjefShopExpandDetails(data) {
  return request({
    url: "/ajef-shop-expand/getAjefShopExpandDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户其他信息-编辑商户介绍
export function updateAjefShopExpandIntroduce(data) {
  return request({
    url: "/ajef-shop-expand/updateAjefShopExpandIntroduce",
    method: "POST",
    data: qs.stringify(data),
  });
}

// ==================== 移动纠错订单 ====================
// 移动纠错订单-列表查询
export function getAjefRightsFundWrongReplaceList(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/getAjefRightsFundWrongReplaceList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 移动纠错订单-执行更新状态
export function updateAjefRightsFundWrongReplaceSync(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/updateAjefRightsFundWrongReplaceSync",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 移动纠错订单-更新扣减SKU
export function updateAjefRightsFundWrongReplaceSku(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/updateAjefRightsFundWrongReplaceSku",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 移动纠错订单-执行
export function updateAjefRightsFundWrongReplaceAction(data) {
  return request({
    url: "/ajef-rights-fund-wrong-replace/updateAjefRightsFundWrongReplaceAction",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 可领取八五折券手机号-列表查询
export function getAjefPhoneEightFiveList(data) {
  return request({
    url: "/ajef-phone-eight-five/getAjefPhoneEightFiveList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-新增
export function addAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/addAjefPhoneEightFive",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-编辑
export function updateAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/updateAjefPhoneEightFive",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-删除（支持批量）
export function deleteAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/deleteAjefPhoneEightFive",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 可领取八五折券手机号-批量导入
export function uploadAjefPhoneEightFive(data) {
  return request({
    url: "/ajef-phone-eight-five/uploadAjefPhoneEightFive",
    method: "POST",
    data,
  });
}